import { useParams } from "react-router-dom";

export const usePortfolioGroupParams = () => {
  const params = useParams();

  const portfolioGroupId = params.portfolioGroupId;
  if (!portfolioGroupId) {
    throw new Error("portfolioGroupId is undefined");
  }

  const portfolioGroupVersionId = params.portfolioGroupVersionId;

  return {
    portfolioGroupId,
    portfolioGroupVersionId,
    isViewPortfolioGroupVersionMode: !!portfolioGroupVersionId,
  };
};
